import Declaration from './declaration.json';
import Error from './error.json';
import Form from './form.json';
import Page from './page.json';
import Payment from './payment.json';
import Plan from './plan.json';
import Quotation from './quotation.json';
import Review from './review.json';
import document from './document';

export const en = {
  translation: {
    ...Page,
    ...Form,
    ...Quotation,
    ...Plan,
    ...Declaration,
    ...Payment,
    ...Review,
    ...Error,
  },
  document,
};
